exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".show {\n    overflow-y: scroll;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/deliverable-tile-uptodate/deliverable-tile-uptodate.component.css
// module id = 819
// module chunks = 0